import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { InfoIcon } from '@/components/UI/Icons/Icons';
import { STEP_ICON_WIDTH } from '@/components/Payment/PaymentInTerminals.constants';

export const Container = styled.div<{ $hasBg?: boolean }>`
  padding: 15px;

  ${({ $hasBg }) =>
    $hasBg &&
    css`
      background-color: ${({ theme }) => theme.palette.primary.background};
    `}
`;

export const PhoneLabel = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  margin-bottom: 5px;
`;

export const PhoneBox = styled.div`
  padding: 10px;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const Phone = styled(Typography.Numbers)`
  text-align: center;
  background: ${({ theme }) => theme.palette.gradient.main};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Divider = styled.div<{ $isSmall?: boolean }>`
  background-color: ${({ theme }) => theme.palette.primary.border};
  height: 1px;
  margin: ${({ $isSmall }) => ($isSmall ? '10px 0' : '15px 0')};
`;

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas:
    'label label'
    'value valueBold';
  gap: 5px;
`;
export const InfoLabel = styled(Typography.Body)`
  grid-area: label;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
export const InfoValue = styled(Typography.Body)`
  grid-area: value;
`;
export const InfoValueBold = styled(Typography.Header)`
  grid-area: valueBold;
  justify-self: end;
`;

export const Title = styled(Typography.Header)`
  margin: 5px 0 15px;
`;

export const Steps = styled.div`
  margin-bottom: 5px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: calc(${STEP_ICON_WIDTH}px / 2 - 0.5px);
    width: 1px;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.primary.border};
  }
`;

export const Step = styled.div`
  display: grid;
  grid-template-columns: ${STEP_ICON_WIDTH}px 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  position: relative;
`;

export const StepIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${STEP_ICON_WIDTH}px;
  height: ${STEP_ICON_WIDTH}px;
  border-radius: 50px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-size: 14px;
  font-weight: 400;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const SubStep = styled(Step)`
  grid-column: 1/-1;
  margin-left: 40px;
`;

export const SubStepIcon = styled(StepIcon)`
  position: relative;

  img {
    width: 17px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -25px;
    width: 25px;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.primary.border};
  }
`;

export const EWallets = styled.div`
  display: grid;
  grid-template-columns: 35px 1fr;
  gap: 15px;
  align-items: center;
  justify-items: center;
`;

export const EWalletsText = styled.div`
  > * {
    display: inline;
  }
`;

export const Notifications = styled.div`
  padding: 15px;
  border-radius: 7px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
  margin-bottom: 15px;
  position: relative;
`;

export const NotificationIcon = styled(InfoIcon)`
  position: absolute;
  top: -9px;
  left: 15px;
`;

export const Notification = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
